import { defineStore, acceptHMRUpdate } from 'pinia';
import i18n from '@/js/plugins/i18n';
import ProjectSrv from '@/components/Projects/ProjectSrv';
import useUsersStore from '@/stores/users';
import useUsersGroupsStore from '@/stores/users/groups';
import useUsersAccessRightStore from '@/stores/users/accessRight';

function getInitialState() {
  return {
    dataLoaded: { company: null, company_error: "", projects: null, projects_error: "" },
    projects: [],
    openedProjects: [],
    openedUsers: [],
    openedGroup: null,
    manageTabIndex: null,
  };
}

const store = defineStore('manage', {
  state: () => getInitialState(),

  getters: {
    canIOpenUser() {
      return (user) => {
        const usersStore = useUsersStore();
        const accessRightStore = useUsersAccessRightStore();

        if (user.id == usersStore.user.id) return true;
        if (! accessRightStore.isAdmin) return false;
        if (! usersStore.user.organization) return true;
        return usersStore.getOrganizationSubCompanies.find(company => (company.users || []).find(item => item.id == user.id)) && true || false;
      };
    },
    canIEditUserRights() {
      return (user) => {
        if (['consult', 'user', 'company_admin'].indexOf(user.access_right) === -1) return false;
        const accessRightStore = useUsersAccessRightStore();
        return !! (accessRightStore.isAdmin && this.canIOpenUser(user));
      };
    },
  },

  actions: {
    reset(values) {
      _.extend(this.$state, getInitialState(), values);
    },
    loadCompany() {
      const usersStore = useUsersStore();
      return usersStore.getMe().then(() => {
        this.dataLoaded.company = true;
      }).catch((message) => {
        this.dataLoaded.company_error = message || i18n.global.t("GLOBAL.ERROR");
        console.error('Error loading company', message);
      });
    },
    loadProjects() {
      return ProjectSrv.list().then((response) => {
        this.projects = response;
        this.dataLoaded.projects = true;
      }).catch((message) => {
        this.dataLoaded.projects_error = message || i18n.global.t("GLOBAL.ERROR");
        console.error('Error loading projects', message);
      });
    },
    reload() {
      this.openedProjects = [];
      this.openedUsers = [];
      this.loadCompany();
      this.loadProjects();
      useUsersGroupsStore().load();
      this.openedGroup = null;
    },
    openProject(project) {
      $(window).scrollTop(0);
      const projectIndex = this.openedProjects.indexOf(project);
      if (projectIndex == -1) this.openedProjects.push(project);
      setTimeout(() => {
        this.manageTabIndex = `projects-project${project.id}`;
      });
      this.openedGroup = null;
    },
    openProjectFromId(projectId) {
      this.manageTabIndex = `projects-projects`;
      if (this.dataLoaded.projects_error) return;
      if (! this.dataLoaded.projects) {
        setTimeout(() => { this.openProjectFromId(projectId); }, 300);
        return;
      }
      const project = this.projects.find(item => item.id == projectId);
      if (project) this.openProject(project);
    },
    openUser(user) {
      if (! this.canIOpenUser(user)) return;
      $(window).scrollTop(0);
      this.openedGroup = null;
      const userIndex = this.openedUsers.indexOf(user);
      if (userIndex == -1) this.openedUsers.push(user);
      setTimeout(() => {
        this.manageTabIndex = `company-user${user.id}`;
      });
    },
    openUserFromId(userId) {
      const user = useUsersStore().getOrganizationUsers.find(item => item.id == userId);
      if (user) this.openUser(user);
    },
  },
});

export default store;

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
}
